import { UIImage } from "./ui/uiImage";
import { UIManager } from "./ui/uiManager";
import { AlertDialog } from "./alertDialog";
import { MessageDialog } from "./messageDialog";
import { QuestionDialog } from "./questionDialog";
import { UIDialogOptions } from "./ui/uiDialog";
import { SettingsDialog } from "./settingsDialog";
import { PauseDialog } from "./pauseDialog";
import { Server } from "../../server/server";
import { PlayPlaceMenu } from "./playPlaceMenu";

export class GameBase {
  // public boxImage: string;
  public alertDialog: AlertDialog;
  public messageDialog: MessageDialog;
  public questionDialog: QuestionDialog;
  public pauseDialog: PauseDialog;
  public playPlaceMenu: PlayPlaceMenu;
  public dialogStyle: UIDialogOptions;
  // public roomDialog: RoomDialog;
  // public inviteFriendsDialog: InviteFriendsDialog;
  public settingsDialog: SettingsDialog;
  protected callback: Function;
  protected canvas: HTMLCanvasElement;
  protected gameId: string;
  protected tournament: boolean;

  constructor(canvas:HTMLCanvasElement, callback:Function, gameId:string, tournament:boolean) {
    this.canvas = canvas;
    this.callback = callback;
    this.gameId = gameId;
    this.tournament = tournament;
  }

  public load() {
    UIManager.connect(this.canvas);
    UIManager.setFrameRate(UIManager.isMobile ? 40 : 60);

    this.messageDialog = new MessageDialog(this.dialogStyle);
    this.messageDialog.build();
    this.alertDialog = new AlertDialog(this.dialogStyle);
    this.alertDialog.build();
    this.questionDialog = new QuestionDialog(this.dialogStyle);
    this.questionDialog.build();
    this.pauseDialog = new PauseDialog(this.dialogStyle);
    this.pauseDialog.build();
    this.playPlaceMenu = new PlayPlaceMenu(this.dialogStyle);
    this.playPlaceMenu.build();
  }

  public unload() {
    this.messageDialog = null;
    this.alertDialog = null;
    this.questionDialog = null;
    this.pauseDialog = null;
    this.playPlaceMenu = null;
    UIManager.disconnect();
    UIImage.cleanupImageCache();

    Server.messages.removeEventListener('chat-started', null);
    Server.messages.removeEventListener('chat-updated', null);
    Server.user.removeEventListener('friend-updated', null);
  }

  public showMessage(message:string, callback:Function = ()=>{}) {
    this.messageDialog.setMessage(message);
    this.messageDialog.showModal(callback);
  }

  public hideMessage() {
    this.messageDialog.hide();
  }

  public showAlert(question:string, callback:Function = ()=>{}) {
    this.alertDialog.setMessage(question);
    this.alertDialog.showModal(callback);
  }

  public askQuestion(question:string, callback:Function = ()=>{}) {
    this.questionDialog.setMessage(question);
    this.questionDialog.setButtons(['No', 'Yes']);
    this.questionDialog.showModal(callback);
  }

  public quit() {
    this.callback('quit');
  }

  public showSettings(callback:Function=null) {
    this.settingsDialog.showModal((settings:any)=>{
      if(settings)
        this.start(settings);
      if(callback)
        callback(settings != null);
    });
  }

  public start(settings:any = null) {
    // if(Site.room.isActive()) {

    //   if(Site.room.isLocalPlayerHost()) {
    //     Site.room.sendEvent({
    //       id: 'start-game',
    //       settings: this.stringifySettings(settings)
    //     });
    //     // Site.room.setState('playing');
    //   }

    //   Site.room.setLocalPlayerState('playing', true);
    // }
  }

  public registerState: string = 'waiting';

  public async registerGame() {
    this.registerState = 'registering';
    let response = await Server.games.startGame(this.gameId, this.tournament);
    this.registerState = response.success ? 'success' : 'fail';
  }

  public async recordScore(score:number, callback:Function) {
    if(this.registerState != 'success') {
      setTimeout(() => {
        callback(false, 0, 0);
      }, 1000);
      return;
    }

    let response = await Server.games.finishGame(this.gameId, this.tournament, score);
    if(response.success) 
      callback(true, response.highScore, response.coins, response.asset);
    else 
      callback(false, 0, 0);
  }

  public isTournament():boolean {
    return this.tournament;
  }
}